import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DataTip, T } from '../../../components/Translations';
import { ApiUrl /*, AppPages*/ } from '../../../project/Defines';
import { dispatchCustomEvent, EVENT_NAME } from '../../../project/utilities';
import InputCont from '../../../Shared/Form/InputCont';
import { ValidationUpload } from '../../../Shared/Form/validation';
import useDetail from '../../../Shared/useDetail';
import uuidv4 from 'uuid/v4';
import { Ajax } from '../../../components/Ajax';

/**
 * ContractAttachment detail of ContractAttachmentDetail
 * @exports ContractAttachmentDetails
 */
export default function ContractAttachmentDetails(props) {
  const { windowKey, parentData, isNewCall, setDataSource } = props.detailProps;
  const listUpdateEvent = EVENT_NAME.ATTACHMENTS_CONTRACT_LIST_UPDATE;
  const [validationFields, setValidationFields] = useState([]);

  const { dataItem, setDataItem, updateData, closePopup, validation } = useDetail({
    data: { ID: "", images: [], ImageItems: [], service_contract_uuid: parentData?.ID },
    updateUrl: !isNewCall && ApiUrl.ContractAttachmentsUpdate,
    windowKey,
    //dataLoadUrl: !isNewCall && ApiUrl.ContractAttachmentsLoad,
    updateLocally: isNewCall,
    // deleteUrl: ApiUrl.ContractAttachmentsDelete,
    //  onLoadData,
    listUpdateEvent,
    validationFields,
    changingValidation: true,
    // additionalData: { service_job_uuid: parentData.ID }
  });
  useEffect(() => {
    setValidationFields([...(dataItem?.images.map((image, i) => `images[${i}].name`) || [])]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataItem?.images]);

  const updateSuccessCallback = useCallback((response) => {
    dispatchCustomEvent(listUpdateEvent, { action: 'update' });
    closePopup();
  }, [closePopup, listUpdateEvent]);

  const updateForNewCall = () => {
    setDataSource(d => ([...d.map((item, index) => ({ ...item })), ...dataItem.images.map((i, index) => ({ attachment_name: i.name, images: [i], ID: uuidv4()}))]));
    closePopup();
  };

  const onNameChange = useCallback((e, i) => {
    const newValue = e.target.value;

    const newData = { ...dataItem };
    newData.images[i].name = newValue;
    setDataItem(newData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataItem]);

  return (<>
    {dataItem &&
      <form>
        <div className='form_container'>
          <div className='section_group'>
            <div className='sections '>

              <ValidationUpload
                validation={validation}
                hideLink
                listType='text'
                className='simple'
                anyFile
                multiple
                fileNameField='attachment_name'
                imageUrl='image_url'
                imageField='images'
                dataItem={dataItem}
                setDataItem={setDataItem}
                type={'service_contract_attachments'}
              />
              
              {dataItem.images?.map((image, i) => {
                return <InputCont 
                  key={dataItem.images[i].image_guid}
                  inputProps={{ 
                    name: `images[${i}].name`, 
                    validation: validation, 
                    value: dataItem.images[i].name,
                    placeholder: "", 
                    onChange: (e) => onNameChange(e, i) }}
                    icon={<> {// eslint-disable-next-line
                      dataItem.images[i].image_url && <a 
                      onClick={() => {
                          let url = dataItem.images[i].image_url;
                          Ajax.downloadGet({
                              url: url,
                              target: '_blank',
                              autoDownload: true,
                              absolute:true,
                              data: {
                                  
                              },
                              success: function (response) {
                              },
                              error: function (response) {
                              }
                          });
                        }}
                      ><DataTip title={dataItem.images[i].name}><icon>eye</icon></DataTip></a>} { /*eslint-disable-line react/jsx-no-target-blank*/}
                    </>}
                />}
              )}
            </div>
          </div>
        </div>

        <toolbar>
          <wrap>
            <action right=''>
              <div onClick={(e) => updateData(isNewCall ? updateForNewCall : updateSuccessCallback)} className='button'
              ><icon>save</icon><T>text.save</T></div>
            </action>
          </wrap>
        </toolbar>
      </form>
    }
  </>);
}

ContractAttachmentDetails.propTypes = {
    detailProps: PropTypes.shape({
        windowKey: PropTypes.string.isRequired,
        parentData: PropTypes.object,
        isNewCall: PropTypes.bool,
        setDataSource: PropTypes.func
    }).isRequired
};